
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["fill-current",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 10","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.116 1.116a1.25 1.25 0 0 1 1.768 0L8 6.232l5.116-5.116a1.25 1.25 0 0 1 1.768 1.768l-6 6a1.25 1.25 0 0 1-1.768 0l-6-6a1.25 1.25 0 0 1 0-1.768"}})])
          )
        }
      }
    